
import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { IAuthenticationContainerState } from "./authentication";
import {
    login,
    logout,
    setUser
} from "./authentication.actions";

const mapState = ({ authentication }: IStoreState): IAuthenticationContainerState => ({ ...authentication });

const actions = {
    login,
    logout,
    setUser,
};

export type IAuthenticationContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [AuthenticationContainer, connectWithAuthentication, useAuthentication] = generateContainer(mapState, actions);
